import { createApiReducer } from 'reacticoon/reducer'
import { fetchSearch } from './actions'

const searchReducer = createApiReducer(fetchSearch)

export default searchReducer
